import { get } from 'lodash';
import React, { FC } from 'react';
import { ABSCHLUSS_HINWEISE_TABS } from 'src/lib/constants/constant';
import AbschlussAngabenPruefen from './content/AbschlussAngabenPruefen';
import AbschlussAntragHerunterladen from './content/AbschlussAntragHerunterladen';
import AbschlussFoerderungBeantragen from './content/AbschlussFoerderungBeantragen';
import AbschlussWeitere from './content/AbschlussWeitere';

const GetAbschlussContent: FC<{ hinweis: any; paths: any }> = ({ hinweis, paths }) => {
	const untertitel = get(hinweis, paths.UnterTitel, '');
	const tab = get(hinweis, paths.Tab, '');
	const inhalt = get(hinweis, paths.Inhalt, '');
	switch (tab) {
		case ABSCHLUSS_HINWEISE_TABS.AngabenPruefen:
			return <AbschlussAngabenPruefen untertitel={untertitel} inhalt={inhalt} />;
		case ABSCHLUSS_HINWEISE_TABS.AntragHerunterladen:
			return <AbschlussAntragHerunterladen untertitel={untertitel} inhalt={inhalt} />;
		case ABSCHLUSS_HINWEISE_TABS.FoerderungBeantragen:
			return <AbschlussFoerderungBeantragen untertitel={untertitel} inhalt={inhalt} />;
		default:
			return <AbschlussWeitere untertitel={untertitel} inhalt={inhalt} />;
	}
};

export default GetAbschlussContent;
